<template>

  <div class="vclient-table">
    <div class="w-full h-full fixed left-0 top-0 bg-white bg-opacity-50 z-50" v-if="isLoading">
      <loader :label="$t('frontend_loading')" />
    </div>
    <confirm-modal ref="deleteModal" name="delete-category" :callback="confirmDelete"
      :button-text="this.$t('frontend_delete')"></confirm-modal>
    <portal to="headerContent">
      <gd-button size="auto" class="px-8 h-10" variant="primary" @click="createCategoryModal">{{
        $t('frontend_grooveblog_new_category') }}</gd-button>
    </portal>
    <gd-modal name="create-category-modal" :title="$t('frontend_grooveblog_add_new_category')">
      <div class="flex flex-col px-8 py-5">
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">{{ $t('frontend_name') }}</label>
          <text-input class="" v-model="post.name" :validator="$v.post.name" placeholder="" />
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">Slug</label>
          <text-input class="" v-model="post.slug" :validator="$v.post.slug" placeholder="" />
          <div class="text-grey-500 mt-1">{{ $t('frontend_yourblogname_slash_categoryname') }}</div>
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">{{ $t('frontend_desc') }}</label>
          <text-area v-model="post.description" class="w-full modal-textarea" :validator="$v.post.description"
            placeholder="" @keyup="usedCount = post.description.length" />
          <div class="text-grey-500 mt-1">
            {{ $t('frontend_grooveblog_max_500_char') }} {{ usedCount }}
          </div>
        </div>
        <div class="flex flex-row items-center w-full mb-4">
          <label class="text-grey-dark mr-4">{{ $t('frontend_grooveblog_show_in_navigation') }}</label>
          <gd-toggle dark v-model="visibleNav" />
        </div>
        <div class="flex flex-row w-full mt-4 justify-center">
          <gd-button class="text-center h-10 border-grey-1" size="large" variant="outline" @click="closeCategoryModal">{{
            $t('frontend_cancel') }}</gd-button>
          <gd-button class="text-center h-10 ml-4" size="large" variant="primary" @click="submitData">{{
            $t('frontend_done') }}</gd-button>
        </div>
      </div>
    </gd-modal>

    <gd-modal name="edit-category-modal" :title="$t('frontend_grooveblog_edit_category')">
      <div class="flex flex-col px-8 py-5">
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">{{ $t('frontend_name') }}</label>
          <text-input class="" v-model="post.name" :validator="$v.post.name" placeholder="" />
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">Slug</label>
          <text-input class="" v-model="post.slug" :validator="$v.post.slug" placeholder="" />
          <div class="text-grey-500 mt-1">{{ $t('frontend_yourblogname_slash_categoryname') }}</div>
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="text-grey-dark mb-2">{{ $t('frontend_desc') }}</label>
          <text-area v-model="post.description" class="w-full modal-textarea" :validator="$v.post.description"
            @keyup="usedCount = post.description.length" placeholder="" />
          <div class="text-grey-500 mt-1">
            {{ $t('frontend_grooveblog_max_500_char') }} {{ usedCount }}
          </div>
        </div>
        <div class="flex flex-row items-center w-full mb-4">
          <label class="text-grey-dark mr-4">{{ $t('frontend_grooveblog_show_in_navigation') }}</label>
          <gd-toggle dark v-model="visibleNav" />
        </div>
        <div class="flex flex-row w-full mt-4 justify-center">
          <gd-button class="text-center h-10 border-grey-1" size="large" variant="outline"
            @click="closeEditCategoryModal">{{ $t('frontend_cancel') }}</gd-button>
          <gd-button class="text-center h-10 ml-4" size="large" variant="primary" @click="updateCategory">{{
            $t('frontend_update') }}</gd-button>
        </div>
      </div>
    </gd-modal>
    <client-table class="grooveblog-categrory-table" :tableRef="'categroryTable'" :tableColumns="categoriesTableColumns"
      :tableOptions="categoriesTableOptions" :tableData="categories" :tableCondition="categories.length"
      :slotData="slotData"
      >

    </client-table>
    <div class="flex justify-center"  v-if="!categories.length && !isLoading">
      <!-- :empty_state_sub_heading="$t('frontend_grooveblog_no_post_added_sub_heading')" -->
      <empty-state :empty_state_heading="$t('frontend_grooveblog_no_category_added')"
        :empty_state_button_text="$t('frontend_grooveblog_new_category')" @executeDataCreation="createCategoryModal">
      </empty-state>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Loader from '@groovepages/gd-ui-kit/components/Loader';
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import EmptyState from '@groovepages/gd-ui-kit/components/tables/EmptyState';
import ClientTable from '@groovepages/gd-ui-kit/components/tables/ClientTable.vue';
import axios from 'axios';
import themeConfig from '@/theme/themeConfig.js';

const MODAL_CLOSE = 'modal-close';
const CREATE_CATEGORY_MODAL = 'create-category-modal';
const EDIT_CATEGORY_MODAL = 'edit-category-modal';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Categories' };
  },
  components: { Loader, ClientTable, ConfirmModal , EmptyState},
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      blogId: '',
      categoryToDelete: null,
      categories: [],
      categoriesTableColumns: ['name', 'slug', 'blogposts', 'actions'],
      categoriesTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: ['blogposts'],
        headings: {
          name: this.$t('frontend_grooveblog_category_name'),
          blogposts: this.$t('frontend_grooveblog_blogposts'),
          actions: '',
        },
        filterByColumn: false,
        filterable: ['name'],
        perPage: 6,
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      visibleNav: false,
      post: {
        blog_id: '',
        name: '',
        slug: '',
        description: '',
        visible: '',
      },
      selectedCategoryId: '',
      usedCount: 0,
    };
  },
  validations: {
    post: {
      name: {
        required,
      },
      slug: {
        required,
      },
      description: {
        required,
        maxLength: maxLength(500),
      },
    },
  },
  mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.getCategory(this.blogId);
  },
  methods: {
    createCategoryModal() {
      this.post = {};
      this.$root.$emit('modal-open', CREATE_CATEGORY_MODAL);
    },
    closeCategoryModal() {
      this.$root.$emit(MODAL_CLOSE, CREATE_CATEGORY_MODAL);
    },
    closeEditCategoryModal() {
      this.$root.$emit(MODAL_CLOSE, EDIT_CATEGORY_MODAL);
    },
    async getCategory(blogId) {
      this.showLoader();
      await axios
        .get(`/categories?blog_id=${blogId}`)
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    async deleteCategory(category) {
      this.$refs.deleteModal.open();
      this.categoryToDelete = category;
    },
    confirmDelete() {
      this.showLoader();
      axios
        .delete(`/categories/${this.categoryToDelete.id}`)
        .then(() => {
          const deletedCategory = this.categories
            .map((item) => item.id)
            .indexOf(this.categoryToDelete.id);
          this.categories.splice(deletedCategory, 1);
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });

      this.$refs.deleteModal.close();
    },
    getSelectedCategory() {
      this.showLoader();
      axios
        .get(`/categories/${this.selectedCategoryId}`)
        .then((response) => {
          this.post = response.data.data;
          this.visibleNav = this.post.visible;
          this.usedCount = this.post.description.length;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateCategory() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$v.$reset();
        this.showLoader();
        this.post.slug = this.post.slug
          .replace(/[^A-Z0-9/_]+/gi, '-')
          .toLowerCase();
        axios
          .put(`/categories/${this.selectedCategoryId}`, {
            name: this.post.name,
            slug: this.post.slug,
            description: this.post.description,
            parent_id: this.post.parent_id,
            order: this.post.order,
            visible: this.visibleNav,
          })
          .then(() => {
            this.getCategory(this.blogId);
            this.$root.$emit(MODAL_CLOSE, EDIT_CATEGORY_MODAL);
            this.hideLoader();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    addCategory() {
      this.$router.push({ name: 'create_category' });
    },
    editCategory(id) {
      this.selectedCategoryId = id;
      this.getSelectedCategory();
      this.$root.$emit('modal-open', EDIT_CATEGORY_MODAL);
    },
    async submitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$v.$reset();
        this.showLoader();
        this.post.blog_id = this.blogId;
        this.post.slug = this.post.slug
          .replace(/[^A-Z0-9]+/gi, '-')
          .toLowerCase();
        this.post.visible = this.visibleNav;
        await axios
          .post('/categories', this.post)
          .then(() => {
            this.getCategory(this.blogId);
            this.visibleNav = false;
          })
          .catch((error) => {
            console.log(error);
          });
        this.hideLoader();
        this.$root.$emit(MODAL_CLOSE, 'create-category-modal');
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
  computed: {
    slotData() {
      return [
        {
          slotName: 'actions',
          slotType: 'actions',
          actionList: [
            {
              id: 1,
              name: 'frontend_edit',
              conditions: () => true,
              callback: (props) => this.editCategory(props.row.id),
            },
            {
              id: 2,
              name: 'frontend_delete',
              conditions: () => true,
              callback: (props) => this.deleteCategory(props.row),
            },
          ],
        },
      ];
    },
  }
};
</script>

<style lang="scss">
.vclient-table {
  .VueTables__search .VueTables__search-field {
    display: none;
  }

  .VueTables--client table {
    overflow: auto !important;
  }

  .VueTables__heading {
    color: #8f92ab;
  }

  .VueTables__sort-icon {
    color: #8f92ab;
    margin-left: 8px;
  }

  td {
    font-weight: 200;
  }

  .VueTables__child-row-toggler--closed::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 7l-.707031.707031 6.125 6.125 1.875 1.875 1.875-1.875 6.125-6.125-.707031-.707031-6.125 6.125-1.167969 1.167969-1.167969-1.167969-6.125-6.125' /></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__child-row {
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-left: 5px solid var(--brand-primary);
  }

  .VueTables__child-row-toggler--open::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 1044.3622l-.707031-.707 6.125-6.125 1.875001-1.875 1.875 1.875 6.125 6.125-.707032.707-6.125-6.125-1.167968-1.168-1.167969 1.168-6.125 6.125' transform='translate(0-1030.3622)'/></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  .VueTables__row {
    border-bottom: 1px solid #ddd;

    td {
      &:first-child {
        width: 30%;
      }

      &:nth-child(2) {
        width: 40%;
      }

      &:nth-child(3) {
        width: 19%;
      }

      &:last-child {
        width: 11%;
      }
    }
  }

  .VueTables__table th,
  td {
    text-align: left;
    padding: 16px;
  }

  tr.VueTables__child-row>td {
    padding: 0px !important;
  }

  thead {
    border-bottom: 1px solid #ddd;
  }

  .vue-pagination-ad {
    text-align: center;
  }

  .VueTables__limit {
    display: none;
  }

  .VuePagination__count {
    display: none;
  }

  .expandIcon {
    display: none;
  }

  .VuePagination__pagination {
    display: flex;
    margin-top: 10px;
    justify-content: flex-end;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .VuePagination__pagination-item {
    padding-left: 2px;
    padding-right: 2px;
  }

  .VueTables__search-field {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #dcdcea;
  }

  .VueTables__search__input {
    border: 1px solid #eee;
    border-radius: 5px;
    margin-left: 10px;
    font-size: 14px;
    padding: 6px !important;
  }
}

.modal-textarea {
  height: 122px;
}

.modal-textarea textarea {
  padding: 16px;
}
</style>
